
























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { DashboardService, Atendimento } from "@/services/dashboard.service";

@Component({
})
export default class QuantidadeAntendentes extends Vue {
  qtdAtendimentos: Atendimento[] = [];
  loadingAtendimentosDashboard = false;

  @Prop() date!: string | null;

  mounted() {
    this.setDateToday();
    this.ListaAtendimentos();
  }

  @Watch("date")
  ListaAtendimentos() {
    this.setDateToday();
    this.CarregarListaAtendimentos();
  }

  setDateToday() {
    if (!this.date) {
      this.date = new Date().toISOString();
    }
  }

  async CarregarListaAtendimentos() {
    this.loadingAtendimentosDashboard = true;
    if (this.date) {
      this.qtdAtendimentos = await DashboardService.ListaAtendimentosDashboard(this.date).finally(
        () => (this.loadingAtendimentosDashboard = false)
      );
    }
  }
}
